import { useEffect, useState } from 'react'
import { Outlet, Navigate } from 'react-router-dom'
import { useSelector } from "react-redux";
import Unauthorized from '../pages/Unauthorized';
import { getAxiosResponse } from "../services/authApiRoutes/APImethods";
import APIUrls from "../services/APIUrls";
import { ConditionalBlock } from '../ConditionalBlock';

const PrivateAuthRoutes = (prop) => {

    const [accessible, setAccessible] = useState(null);
    const bootstrapData = useSelector((store) => store.customer_bootstrap_data).value;

    useEffect(() => {
        getAxiosResponse(APIUrls.CHECK_PAGE_ACCESS+"?url_path="+prop.authUrl)
        .then((res) => {
            let hasRequiredRole = res.data.accessible;
            let hasRequiredPermission = prop.permission ? (bootstrapData?.permissions[prop.permission] === true) : true;
            const accessible = (hasRequiredRole && hasRequiredPermission);
            setAccessible(accessible);
        })
    })

    return(
        <>
            <ConditionalBlock condition={accessible === true}>
                <Outlet/>
            </ConditionalBlock>
            <ConditionalBlock condition={accessible === false}>
                <Unauthorized/>
            </ConditionalBlock>
        </>
    )
}

export default PrivateAuthRoutes